import { useQuery } from '@tanstack/react-query';
import { fetchApiRef, useApi } from '@backstage/frontend-plugin-api';

// Cluster metadata from the radix GET /clusters endpoint. Hosts and labels live
// on the backend, so cluster IDs can be resolved without duplicating the mapping here.
export type RadixClusterInfo = {
  id: string;
  host: string;
  category: 'production' | 'playground';
  label: string;
};

export function useRadixClusters() {
  const fetchApi = useApi(fetchApiRef);

  const { data, isLoading, error } = useQuery({
    queryKey: ['radix', 'clusters'],
    queryFn: async (): Promise<RadixClusterInfo[]> => {
      // The 'plugin://' protocol lets fetchApi resolve the radix backend base URL.
      const response = await fetchApi.fetch('plugin://radix/clusters');
      if (!response.ok) {
        throw new Error(
          `Failed to fetch Radix clusters: ${response.status} ${response.statusText}`,
        );
      }
      return (await response.json()) as RadixClusterInfo[];
    },
    staleTime: Infinity,
  });

  return { clusters: data ?? [], isLoading, error };
}
